import React, { useState } from 'react';

// Component
import JalaliDatePicker from './JalaliDatePicker';
import GregorianDatePicker from './GregorianDatePicker';

const CustomDatePicker = ({ defaultVal, label, onChange, name, webConfig }) => {
	const [val, setVal] = useState(defaultVal || null);

	return (
		<>
		{webConfig.lang === 'fa' ?
		<JalaliDatePicker
			label={label}
			val={val}
			handleChange={(UTCDate) => onChange({[name]: UTCDate.replace('Z', '')})}
		/>
		:
		<GregorianDatePicker
			label={label}
			val={val}
			handleChange={(UTCDate) => onChange({[name]: UTCDate.replace('Z', '')})}
		/>
		}
		</>
	);
};

export default CustomDatePicker;